module.exports = __webpack_public_path__ + "img/44.b0c3e3fc.jpg";